import { CharacterInitializer } from "../../characters/Character";
import { Roller } from "../Roller";
import { RhetoricName } from "./RhetoricMap";

export enum RhetoricPriority {
    None = 0,
    Primary = 1,
    Secondary = 2,
    Tertiary = 3
}

export type RhetoricInitializer = {
    id: string;
    name: RhetoricName;
    description: string;
}

export const DefaultRhetoricInitializer: RhetoricInitializer = {
    id: '',
    name: 'Charisma',
    description: ''
}

const getLevel = (rhetoricId: string, character: CharacterInitializer) => {
    const reference = character.rhetorics.find(ref => ref.id == rhetoricId);
    if (reference == null) {
        throw "No matching rhetoric reference found.";
    }

    if (reference.override) {
        return reference.override;
    }

    let baseLevel = 0;
    switch (reference.priority) {
        case RhetoricPriority.Primary:
            baseLevel = Math.ceil(character.level * 0.33) + 1;
            break;
        case RhetoricPriority.Secondary:
            baseLevel = Math.ceil(character.level * 0.25) + 1;
            break;
        case RhetoricPriority.Tertiary:
            baseLevel = Math.ceil(character.level * 0.2) + 1;
            break;
    }
    return baseLevel + reference.adjustment;
}

const getRoller = (rhetoricId: string, character: CharacterInitializer) => {
    const level = getLevel(rhetoricId, character);
    return new Roller(level * 2);
}

export const RhetoricHelpers = Object.freeze({
    getLevel,
    getRoller,
    minValue: 1,
    maxValue: 10,
})